export default "__VITE_ASSET__Bw3Dhv6S__"